// File Metadata:
// Filename: QualityMetrics.js
// Version: 1.00
// Created: 2025-03-23 01:04:41
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Paper, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'

const QualityMetrics = ({ receptions }) => {
    const receptionsList = Object.values(receptions?.entities || {})
    const metrics = {
        total: receptionsList.length,
        pending: receptionsList.filter(r => r.qualityStatus === 'PENDING_APPROVAL').length,
        approved: receptionsList.filter(r => r.qualityStatus === 'APPROVED').length,
        rejected: receptionsList.filter(r => r.qualityStatus === 'REJECTED').length,
        needsReview: receptionsList.filter(r => r.qualityStatus === 'NEEDS_REVIEW').length
    }

    return (
        <Grid container spacing={2}>
            {Object.entries(metrics).map(([key, value]) => (
                <Grid xs={6} key={key}>
                    <Paper sx={{ p: 2, textAlign: 'center' }}>
                        <Typography variant="h6">{value}</Typography>
                        <Typography variant="subtitle2">
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                        </Typography>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    )
}

// Add trend analysis
const QualityTrends = ({ data }) => {
    // Implement trend visualization
}

export default QualityMetrics
